export default __webpack_public_path__ + "static/luigi-giani-f186cf9a9b563bfceab8de84b0360f34.jpeg";